<template>
  <AlertBlock
    v-if="model?.vars?.label && !model.vars.hide"
    :type="alertType"
    :icon="model.vars.icon ?? ''"
    :text="model.vars.label"
    :class="model.vars.attr?.class"
  />
</template>

<script>
import AlertBlock from "@/components/blocks/AlertBlock.vue";

const ALERT_TYPES = ["info", "success", "warning", "danger"];

export default {
  name: "AlertTypeComponent",
  components: { AlertBlock },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    alertType() {
      return ALERT_TYPES.includes(this.model.vars.type) ? this.model.vars.type : "info";
    },
  },
};
</script>
